import { type MutableRefObject } from 'react';
import { type Maybe } from '@gql/schema';

export enum FocusedInput {
  StartDate = 'startDate',
  EndDate = 'endDate',
}

export type TFocusedInput = FocusedInput | null;

export interface OfferOptions {
  id: string;
  title: string;
}

export interface AvailabilityPresentationHandle {
  openCalendar: () => void;
  container: MutableRefObject<HTMLDivElement | null>;
}

export interface URLParams {
  tripTypeParam?: Maybe<string>;
  airportCodeParam?: Maybe<string>;
  durationParam?: Maybe<string>;
  airportNameParam: Maybe<string>;
}

export interface DateSelectionTrackingDetails {
  specificDatesSearch: boolean;
  triggeredBy: string;
  numResults: number;
  parameters: {
    airport: string;
    checkInDate: string;
    checkOutDate: string;
    travellersSelection: string;
  };
  results: {
    offerId: string;
    price: string;
    source: string;
  }[];
}
